// extracted by mini-css-extract-plugin
export default {"generalError":"generalerror_generalError__rGbYq","greyError":"generalerror_greyError__32z-c"};